/* Design Set page (Trust, Waymaker, ...): pick the bag's leather, see the set price, add bag + wallet + mini wallet in one tap.
 * Prices on the page are display only; the blessac-discount app prices the cart (gwp campaign, offerKey on each line).
 * Data comes from the section's Liquid as JSON ([data-ts-data]): bag variants with stock, the two gifts, set prices.
 * Cart: window.PICKER_ADD (Horizon adapter, opens the theme cart drawer) when present, else /cart/add.js + /cart.
 * Tracking on every line: _blessac_offer/_role/_lp + the ad's UTM tags kept for the session (first ad click wins). */
(function () {
  var root = document.querySelector('[data-ts]');
  if (!root) return;
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
  var D = {};
  try { D = JSON.parse($('[data-ts-data]').textContent); } catch (e) { return; }
  var PROP = D.offerProp || '_blessac_offer', PRE = PROP.replace(/_offer$/, '');
  var DS = D.design || 'Trust';   // design name for piece names (one script serves every design's Set page)
  var LOW = 30;   // show "Only N left" at or below this many bags

  var UTM = (function () {
    var keys = ['source', 'campaign', 'content'], fromUrl = {}, stored = {};
    try { var q = new URL(window.location.href).searchParams; keys.forEach(function (k) { var v = q.get('utm_' + k); if (v) fromUrl[k] = v.slice(0, 120); }); } catch (e) {}
    try { stored = JSON.parse(sessionStorage.getItem('blessac_utm') || '{}') || {}; } catch (e) {}
    if (!stored.source && fromUrl.source) { stored = fromUrl; try { sessionStorage.setItem('blessac_utm', JSON.stringify(stored)); } catch (e) {} }
    return stored.source ? stored : fromUrl;
  })();

  function money(n) { return '$' + Number(n).toFixed(2); }
  function setText(sel, txt) { $$(sel).forEach(function (el) { el.textContent = txt; }); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]; }); }
  // A gift product missing from the section (unpublished / cleared) arrives as null: the set is paused, not broken.
  // A Deluxe pre-order bag sells while its run is open (Pre-order App mode), not on stock on hand.
  function inStock(v) { return !!v && v.available && (v.preorder ? true : (!v.managed || v.qty > 0)); }

  // Bag choices that have a set price (the campaign prices them the same way): the Deluxe pre-order bag first (the set
  // price the page leads with), then the Original bag's leathers. Set prices are keyed "Deluxe" / Original variant title.
  var deluxe = (D.deluxe || []).filter(function (v) { return v.preorder; }).map(function (v) {
    return {id: v.id, title: v.title, price: v.price, available: v.available, preorder: true, batch: v.batch, eta: v.eta,
            img: v.img, key: 'Deluxe', style: 'Deluxe', name: DS + ' Deluxe Leather Handbag'};
  });
  var original = (D.bag || []).map(function (v) {
    return {id: v.id, title: v.title, price: v.price, available: v.available, managed: v.managed, qty: v.qty,
            key: v.title, style: 'Classic', name: DS + ' Leather Handbag'};
  });
  // Owner 21/10: a sold-out bag choice is hidden, not shown greyed out
  var opts = deluxe.concat(original).filter(function (v) { return D.setPrices && D.setPrices[v.key] != null && inStock(v); });
  // Owner 21/10: with one bag choice (or none) there is nothing to choose, so step 1 is hidden and "2." drops its number
  root.classList.toggle('ts--one', opts.length < 2);
  var giftsOk = inStock(D.wallet) && inStock(D.mini);
  var st = {v: null, busy: false};
  st.v = opts.filter(inStock)[0] || opts[0] || null;
  var thumb = $('[data-ts-bagthumb]'), thumbOriginal = thumb ? thumb.getAttribute('src') : '';

  function sub(v) {
    if (!inStock(v)) return 'Sold out';
    return money(D.setPrices[v.key]) + ' set' + (v.preorder ? ' · Pre-order' + (v.eta ? ', ships ' + v.eta : '') : ' · In stock');
  }

  var mat = $('[data-ts-mat]');
  if (mat) {
    mat.innerHTML = opts.map(function (v, i) {
      var out = !inStock(v);
      return '<button type="button" data-i="' + i + '"' + (out ? ' disabled' : '') + '><b>' + esc(v.style) + ' · ' + esc(v.title) +
        '</b><span>' + esc(sub(v)) + '</span></button>';
    }).join('');
    mat.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-i]');
      if (!b || b.disabled) return;
      st.v = opts[Number(b.getAttribute('data-i'))];
      render();
    });
  }

  function render() {
    var v = st.v;
    $$('[data-ts-mat] button').forEach(function (b) { b.setAttribute('aria-pressed', String(opts[Number(b.getAttribute('data-i'))] === v)); });
    var ready = !!v && inStock(v) && giftsOk;
    if (v && giftsOk) {
      var set = D.setPrices[v.key], worth = v.price + D.wallet.price + D.mini.price;
      setText('[data-ts-wwas]', money(D.wallet.price));
      setText('[data-ts-mwas]', money(D.mini.price));
      setText('[data-ts-bagname]', v.name);
      setText('[data-ts-bagmat]', v.title.charAt(0) + v.title.slice(1).toLowerCase());
      var chip = $('[data-ts-bagchip]');
      if (chip) {
        chip.textContent = v.preorder ? 'Pre-order · ships ' + (v.eta || 'when its run is ready') : 'In stock';
        chip.className = 'ts__chip ' + (v.preorder ? 'is-pre' : 'is-stock');
      }
      if (thumb) thumb.setAttribute('src', v.preorder && v.img ? v.img : thumbOriginal);
      // Owner 21/10: the in-stock wallets ship right away, the Deluxe bag follows when its run is ready
      setText('[data-ts-ship]', v.preorder
        ? 'Your wallet and mini wallet ship now. The Deluxe bag ships ' + (v.eta ? v.eta : 'when its run is ready') + ', from the USA.'
        : 'All three pieces are in stock and ship together from the USA.');
      setText('[data-ts-trust1]', v.preorder ? 'Wallets in stock, bag on pre-order' : 'In stock, ships from the USA');
      setText('[data-ts-bagwas]', money(v.price));
      setText('[data-ts-bagnow]', money(set));
      setText('[data-ts-worth]', money(worth));
      setText('[data-ts-save]', money(worth - set));
      setText('[data-ts-pay]', money(set));
      setText('[data-ts-sticky-p]', 'Set ' + money(set));
    }
    var note = '';
    if (!giftsOk) note = 'The matching wallets are sold out for now, so this set is paused.';
    else if (!v || !inStock(v)) note = 'The ' + DS + ' bags are sold out for now.';
    else if (!v.preorder && v.managed && v.qty <= LOW) note = 'Only ' + v.qty + ' left in ' + v.title.toLowerCase() + '.';
    setText('[data-ts-stock]', note);
    // Nothing buyable (bags out, the pre-order run closed, or a gift out): hide the set rows, ship note and stock line
    // so the placeholder copy ("In stock", a struck price) never sits next to a Sold out button
    root.classList.toggle('ts--paused', !ready);
    var label = st.busy === 'adding' ? 'Adding…' : st.busy === 'added' ? 'Added to cart ✓' : ready ? 'Add to cart' : 'Sold out';
    setText('[data-ts-cta]', label);
    setText('[data-ts-sticky-label]', label);
    $$('[data-fw-cta], [data-fw-sticky-btn]').forEach(function (b) { b.disabled = !ready || !!st.busy; });
  }

  function setError(msg) { var el = $('[data-fw-err]'); if (el) el.textContent = msg; }
  function post(url, body) {
    return fetch(url, {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)})
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (r.ok) return j;
          throw {status: r.status, message: j.description || j.message || ''};
        });
      });
  }
  function addToCart(e) {
    if (st.busy || !st.v) return;
    setError('');
    var base = {};
    base[PROP] = D.offerKey;
    base[PRE + '_lp'] = window.location.pathname;
    if (UTM.source) base[PROP + '_src'] = UTM.source;
    if (UTM.campaign) base[PRE + '_utm_campaign'] = UTM.campaign;
    if (UTM.content) base[PRE + '_utm_content'] = UTM.content;
    function line(id, role) {
      var p = {}; Object.keys(base).forEach(function (k) { p[k] = base[k]; }); p[PRE + '_role'] = role;
      return {id: id, quantity: 1, properties: p};
    }
    var main = line(st.v.id, 'main');
    // Pre-order line properties, the same ones the product page puts on a pre-order bag (Pre-order App reads them)
    if (st.v.preorder) {
      main.properties._preorder = 'true';
      if (st.v.batch) main.properties._preorder_batch = st.v.batch;
      if (st.v.eta) main.properties._preorder_eta = st.v.eta;
    }
    var lines = [main, line(D.wallet.id, 'gift'), line(D.mini.id, 'gift')];
    st.busy = 'adding'; render();
    var run = typeof window.PICKER_ADD === 'function'
      ? window.PICKER_ADD(lines, e && e.currentTarget)
      : post('/cart/add.js', {items: lines}).then(function () { window.location.href = '/cart'; });
    Promise.resolve(run).then(function () {
      st.busy = 'added'; render();
      var live = $('[data-fw-live]'); if (live) live.textContent = 'The ' + DS + ' Set was added to your cart.';
      setTimeout(function () { st.busy = false; render(); }, 1600);
    }).catch(function (err) {
      st.busy = false; render();
      setError(err && err.status === 422 && err.message ? err.message : 'Something went wrong. Please try again.');
      // the tap may have come from the sticky bar far below: bring the message into view
      var box = $('[data-fw-err]'); if (box && box.scrollIntoView) box.scrollIntoView({block: 'center', behavior: 'smooth'});
    });
  }
  $$('[data-fw-cta], [data-fw-sticky-btn]').forEach(function (b) { b.addEventListener('click', addToCart); });
  render();

  // "Size & Photos" under every piece: the same photo sheet as the wallet buy 1 get 2 page (.fw__sheet styles)
  var FACTS = {};
  try { FACTS = JSON.parse($('[data-ts-facts]').textContent); } catch (e) {}
  var sheet = document.createElement('dialog');
  sheet.className = 'fw__sheet';
  sheet.setAttribute('aria-label', 'Details');
  root.appendChild(sheet);
  function closeSheet() { if (sheet.close) sheet.close(); else sheet.removeAttribute('open'); }
  sheet.addEventListener('close', function () { document.documentElement.classList.remove('fw-sheet-open'); });
  sheet.addEventListener('click', function (e) { if (e.target === sheet) closeSheet(); });
  function openSheet(which) {
    var v = st.v, piece;
    if (which === 'bag') {
      if (!v) return;
      piece = {kind: v.style + ' bag', name: v.name, price: v.price, now: D.setPrices[v.key],
               imgs: (D.imgs || {})[v.preorder ? 'deluxe' : 'bag'] || [], facts: FACTS[v.preorder ? 'deluxe' : 'classic'] || [],
               status: v.preorder ? 'Pre-order · ships ' + (v.eta || 'when its run is ready') : 'In stock',
               sub: v.title.charAt(0) + v.title.slice(1).toLowerCase()};
    } else {
      var g = which === 'wallet' ? D.wallet : D.mini;
      if (!g) return;
      piece = {kind: which === 'wallet' ? 'Wallet' : 'Mini wallet', name: DS + (which === 'wallet' ? ' Wallet' : ' Mini Wallet'), price: g.price, now: 0,
               imgs: (D.imgs || {})[which] || [], facts: FACTS[which] || [], status: 'In stock · free in this set',
               sub: 'Premium vegan leather'};
    }
    var imgs = piece.imgs.length ? piece.imgs : [];
    // The bag sheet ends on the Deluxe vs Classic table (owner 21/10), the same one as photo 3 of the page
    var cmp = which === 'bag' ? $('[data-ts-cmp]') : null;
    var slides = imgs.map(function (u) {
      return '<div class="fw__sheet-sl"><img src="' + esc(u) + '" alt="' + esc(piece.name) + '" width="800" height="1000" loading="lazy" decoding="async"></div>';
    });
    if (cmp) slides.push('<div class="fw__sheet-sl ts__cmpsl">' + cmp.outerHTML + '</div>');
    var n = Math.max(slides.length, 1);
    sheet.innerHTML =
      '<div class="fw__sheet-hd"><span class="fw__sheet-kind">' + esc(piece.kind) + '</span>' +
      '<button type="button" class="fw__sheet-x" data-x aria-label="Close">×</button></div>' +
      '<div class="fw__sheet-galwrap">' +
        '<div class="fw__sheet-gal" data-g>' + slides.join('') + '</div>' +
        '<span class="fw__sheet-n" data-n aria-live="polite">1 / ' + n + '</span>' +
        (n > 1 ? '<span class="fw__sheet-swipe" data-swipe aria-hidden="true">Swipe for more photos ›</span>' : '') +
        '<button type="button" class="fw__sheet-arr fw__sheet-arr--p" data-ap aria-label="Previous photo">‹</button>' +
        '<button type="button" class="fw__sheet-arr fw__sheet-arr--n" data-an aria-label="Next photo">›</button>' +
      '</div>' +
      '<div class="fw__sheet-dots" data-d>' + slides.map(function (_, i) { return '<button type="button" data-i="' + i + '"' + (i ? '' : ' aria-current="true"') + ' aria-label="Photo ' + (i + 1) + '"></button>'; }).join('') + '</div>' +
      '<div class="fw__sheet-b">' +
        '<div class="fw__sheet-row"><h3>' + esc(piece.name) + '</h3><span class="pr">' +
          (piece.now ? money(piece.now) : 'FREE') + ' <s>' + money(piece.price) + '</s></span></div>' +
        '<p class="note">' + esc(piece.sub) + ' · ' + esc(piece.status) + '</p>' +
        (piece.facts.length ? '<ul class="ts__facts">' + piece.facts.map(function (f) { return '<li>' + esc(f) + '</li>'; }).join('') + '</ul>' : '') +
        '<button type="button" class="fw__sheet-pick" data-x>Back to my set</button>' +
      '</div>';
    var gal = sheet.querySelector('[data-g]'), dots = sheet.querySelector('[data-d]'), cnt = sheet.querySelector('[data-n]'), sw = sheet.querySelector('[data-swipe]');
    // Slides are narrower than the strip (84%, the next photo peeks in), so position comes from each slide's own
    // offset, and the strip's end counts as the last slide (it can never scroll a peeking last slide to the start).
    var pad = parseFloat(getComputedStyle(gal).paddingLeft) || 0;
    var cur = function () {
      if (gal.scrollLeft >= gal.scrollWidth - gal.clientWidth - 2) return n - 1;
      var best = 0, delta = Infinity;
      Array.prototype.forEach.call(gal.children, function (sl, j) {
        var d = Math.abs(sl.offsetLeft - pad - gal.scrollLeft);
        if (d < delta) { delta = d; best = j; }
      });
      return best;
    };
    var go = function (i) {
      var sl = gal.children[Math.max(0, Math.min(n - 1, i))];
      if (sl) gal.scrollTo({left: sl.offsetLeft - pad, behavior: 'smooth'});
    };
    gal.addEventListener('scroll', function () {
      var i = cur();
      Array.prototype.forEach.call(dots.children, function (b, j) { b.setAttribute('aria-current', String(j === i)); });
      cnt.textContent = (i + 1) + ' / ' + n;
      if (sw && i > 0) sw.hidden = true;
    }, {passive: true});
    dots.addEventListener('click', function (e) { var b = e.target.closest('[data-i]'); if (b) go(Number(b.getAttribute('data-i'))); });
    sheet.querySelector('[data-ap]').addEventListener('click', function () { go(cur() - 1); });
    sheet.querySelector('[data-an]').addEventListener('click', function () { go(cur() + 1); });
    Array.prototype.forEach.call(sheet.querySelectorAll('[data-x]'), function (b) { b.addEventListener('click', closeSheet); });
    if (sheet.showModal) sheet.showModal(); else sheet.setAttribute('open', '');
    document.documentElement.classList.add('fw-sheet-open');
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ts-view]');
    if (b) openSheet(b.getAttribute('data-ts-view'));
  });

  // Gallery: swipe, arrows, counter, dots
  (function () {
    var g = $('[data-jg]'); if (!g) return;
    var t = g.querySelector('[data-jg-track]'), n = t.children.length, c = g.querySelector('[data-jg-count]');
    var th = g.querySelectorAll('[data-jg-thumb]'), timer;
    function idx() { return Math.round(t.scrollLeft / t.clientWidth); }
    function go(i) { i = Math.max(0, Math.min(n - 1, i)); t.scrollTo({left: i * t.clientWidth, behavior: 'smooth'}); }
    function mark() {
      var i = idx(); c.textContent = (i + 1) + ' / ' + n;
      Array.prototype.forEach.call(th, function (b, k) { b.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    t.addEventListener('scroll', function () { clearTimeout(timer); timer = setTimeout(mark, 80); }, {passive: true});
    g.querySelector('[data-jg-prev]').addEventListener('click', function () { go(idx() - 1); });
    g.querySelector('[data-jg-next]').addEventListener('click', function () { go(idx() + 1); });
    Array.prototype.forEach.call(th, function (b, k) { b.addEventListener('click', function () { go(k); }); });
    mark();
  })();

  // Sticky bar: once the shopper has scrolled past the main Add to cart. Horizon scrolls inside .page-wrapper, not the
  // window, so position comes from the button itself (scroll events are caught on the document in the capture phase).
  (function () {
    var sticky = $('[data-fw-sticky]'), cta = $('[data-fw-cta]');
    if (!sticky || !cta || !('IntersectionObserver' in window)) return;
    sticky.inert = true;
    var ctaSeen = true, was = false;
    function sync() {
      var on = !ctaSeen && cta.getBoundingClientRect().bottom < 0;
      sticky.classList.toggle('is-on', on); sticky.inert = !on; sticky.setAttribute('aria-hidden', String(!on));
      if (on !== was) {
        was = on;
        document.documentElement.classList.toggle('fw-sticky-on', on);
        document.documentElement.style.setProperty('--fw-sticky-h', sticky.offsetHeight + 'px');
      }
    }
    new IntersectionObserver(function (en) { ctaSeen = en[0].isIntersecting; sync(); }).observe(cta);
    document.addEventListener('scroll', sync, {passive: true, capture: true});
  })();

})();
